import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import React, { useContext } from 'react';
import {
  Accordion,
  AccordionSize,
  useTPAComponentsContext,
} from 'wix-ui-tpa/cssVars';
import SocialWrapper from '../../SocialWrapper/SocialWrapper';
import AccordionNumberStrip from './AccordionNumberStrip';
import { st, classes } from '../../Widget.st.css';
import settingsParams from '../../../settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import {
  st as accordionStyle,
  classes as accordionClasses,
} from './numbered.st.css';
import RCV from '../../RCV';
import { DraftJSObject } from '../../../../../types/RichContent';
import { AppContext } from '../../SettingsProvider/SettingsProvider';
import { openIconBySettings } from '../../../../../utils/openIconBySettings';
import { useBi } from '@wix/yoshi-flow-editor';
import { faqQuestionExpanded } from '@wix/bi-logger-labs-data/v2';

const NumberOneColumn = ({
  filteredQuestions,
  indexes,
}: {
  filteredQuestions: QuestionEntry[];
  indexes: number[];
}) => {
  const logger = useBi();
  const { mobile } = useTPAComponentsContext();
  const settings = useSettings();
  const noAnimation = !settings.get(settingsParams.enableScrollAnimation);
  const { firstQuestionId, baseURL } = useContext(AppContext);
  const stRootClass = accordionStyle(accordionClasses.root, { noAnimation });
  const layout_type = settings?.get(settingsParams.layout);
  const openQuestionIcon = settings?.get(settingsParams.openQuestionIcon);
  const icons = openIconBySettings(openQuestionIcon);
  const transparentDivider = accordionStyle(
    accordionClasses.transparentDivider,
    { mobile },
  );
  const { gap } = settings.get(settingsParams.spacing);

  const handleAccordionItemClick = (item: string) => {
    const questionData = filteredQuestions.find(
      (q: QuestionEntry) => q.id === item,
    );

    if (questionData) {
      const { question, categoryId, sortOrder } = questionData;
      logger.report(
        faqQuestionExpanded({
          type: layout_type,
          question_id: item,
          question_name: question || '',
          category_id: categoryId || '',
          question_order: sortOrder || 0,
          url: baseURL || '',
        }),
      );
    }
  };

  return (
    <ul
      className={st(classes.numberLayout, {
        mobile,
      })}
    >
      {filteredQuestions.map((item: QuestionEntry, index) => {
        const { id, question, draftjs } = item;
        const parsedDraftjs: DraftJSObject = JSON.parse(draftjs!);

        return (
          <li
            className={st(classes.numberItem, { novspace: gap === 0 })}
            key={id!}
          >
            <AccordionNumberStrip index={indexes[index] - 1} />
            <Accordion
              size={AccordionSize.Small}
              key={`numbered-${firstQuestionId}-${id}`}
              className={accordionStyle(stRootClass, transparentDivider)}
              initiallyExpanded={`${firstQuestionId}`}
              icons={icons}
              onItemClick={(item, isExpanded) =>
                isExpanded && handleAccordionItemClick(item)
              }
            >
              <Accordion.Item
                key={id!}
                id={id!}
                title={question!}
                suffix={<div className={st(classes.hidesuffix)}></div>}
              >
                {parsedDraftjs && <RCV convertAnswerToJSON={parsedDraftjs} />}

                <SocialWrapper questionId={id!} />
              </Accordion.Item>
            </Accordion>
          </li>
        );
      })}
    </ul>
  );
};

export default NumberOneColumn;
